import React, {useContext, useEffect} from 'react';
import {FaExternalLinkAlt, FaPlus, FaPrint} from "react-icons/fa";
import Button from "../../../../../components/button/button.jsx";
import HeaderTemplateButton from "../../../../../components/button/header-template-button.jsx";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {IndividualContext} from "../individual-context.jsx";

const IndividualHeaderActions = ({
    tabSelected,
    headerSelected,
    setHeaderSelected,
    printRef,
}) => {
    const {cpf, permissions, individualInfo} = useContext(IndividualContext)

    const navigate = navigateHook();

    const openForm = () => {
        const url = `/individuals/form`;
        navigate(url)
    }

    const openMonitoring = () => {
        let url = `/individual-monitoring/form?cpf=${cpf}`
        if (individualInfo.monitoringId) {
            url = `/individual-monitoring/form/${individualInfo.monitoringId}`
        }

        navigate(url, true)
    }

    return (
        <div className={"flex flex-row gap-2"}>
            {
                (cpf && tabSelected !== "resume") &&
                <>
                    {
                        permissions.sentryFacePermission &&
                        <Button target={"primary-outline"} onClick={openMonitoring}>
                            <FaExternalLinkAlt/> {individualInfo.monitoringId ? "Monitoramento" : "Cadastro de monitoramento"}
                        </Button>
                    }
                    <Button target={"primary-outline"} onClick={openForm}>
                        <FaPlus/> Adicionar indivíduo
                    </Button>
                </>

            }
            {
                tabSelected === "resume" &&
                <>
                    <Button title="Imprimir" onClick={() => printRef?.current?.print()}>
                        <FaPrint />
                    </Button>

                    <HeaderTemplateButton
                        selected={headerSelected}
                        setSelected={setHeaderSelected}
                    />
                </>
            }
        </div>
    );
};

export default IndividualHeaderActions;
